module.exports = __webpack_public_path__ + "img/youtube.f665b6ad.svg";